import { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const useApiPost = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const postData = async (url, bodyData, contentType = "application/json") => {
    const token = Cookies.get("TheShow_Admin_Token");
    const apiUrl = process.env.REACT_APP_API_URL.replace(/\/$/, ""); // remove trailing slash

    try {
      setLoading(true);
      setError(null);

      const headers = {
        "Content-Type": contentType,
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const response = await axios.post(
        `${apiUrl}${url}`,
        bodyData,
        { headers }
      );

      setData(response.data);
      return response.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const deleteData = async (url) => {
    const token = Cookies.get("TheShow_Admin_Token");
    const apiUrl = process.env.REACT_APP_API_URL.replace(/\/$/, "");

    try {
      setLoading(true);
      setError(null);

      const headers = {
        Accept: "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const response = await axios.delete(
        `${apiUrl}${url}`,
        { headers }
      );

      setData(response.data);
      return response.data;

    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, data, postData, deleteData };
};

export default useApiPost;
